// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-assets_dashboard_js-rewritten-packages_ember-svg-jar_b9dfe8d3_node_modules_ember-svg--6775a6"], () => (__webpack_require__("./assets/dashboard.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
